import {couponAvailable,couponTargets,couponTimestamp,DetailCoupon} from './couponPresentation'
import {validWebActivity} from './activityCoupon'
import {NoteTargeType} from '../Interfaces/enums/NoteType'

export type ReceivedCoupon=DetailCoupon & {id?:number}
export interface CouponReceiptScope {orgId:number;customerId:number}
export function couponReceiptIdentity(ready:boolean,token:any,user:any,orgId:any,verifiedOrgId:any):string {
  const org=Number(orgId),id=Number(user?.id)
  return ready && Boolean(token) && Number.isSafeInteger(org) && org>=1000 && Number(verifiedOrgId)===org
    && Number.isSafeInteger(id) && id>0 && Number(user?.orgId)===org ? JSON.stringify([token,org,id]) : ''
}
export const couponReceiptKey=(scope:CouponReceiptScope,id:number)=>`coupon-received-confirmed:web:${scope.orgId}:${scope.customerId}:${id}`
// 只在客户主动确认后保存；旧的仅展示记录不视为已确认，不改变全账号共用的券已读状态。
export function createCouponReceiptTracker(){
  const session=new Set<string>()
  const seen=(scope:CouponReceiptScope,id:number,read:(key:string)=>any)=>{
    const key=couponReceiptKey(scope,id)
    if(session.has(key))return true
    try{return read(key)==='1'}catch{return false}
  }
  return {
    unseen(notes:ReceivedCoupon[],scope:CouponReceiptScope,read:(key:string)=>any,now=Date.now()):ReceivedCoupon[]{
      const ids=new Set<number>()
      return (Array.isArray(notes)?notes:[]).filter(note=>{
        const id=Number(note?.customerNoteId)
        if(!couponAvailable(note,now) || ![1000,scope.orgId].includes(Number(note.orgId)) || ids.has(id) || seen(scope,id,read))return false
        ids.add(id);return true
      }).sort((a,b)=>Number(a.customerNoteId)-Number(b.customerNoteId))
    },
    remember(notes:ReceivedCoupon[],scope:CouponReceiptScope,_read:(key:string)=>any,write:(key:string,value:string)=>void):boolean {
      // 确认的是已经展示的实例；展示后刚到期/被其他标签确认不能阻塞本批确认。
      if(!notes.length || notes.some(note=>!Number.isSafeInteger(Number(note?.customerNoteId)) || Number(note.customerNoteId)<=0
        || ![1000,scope.orgId].includes(Number(note.orgId))))return false
      for(const note of notes){
        const key=couponReceiptKey(scope,Number(note.customerNoteId));session.add(key)
        try{write(key,'1')}catch{/* 禁止持久存储时仍在当前会话内去重。 */}
      }
      return true
    }
  }
}
export function receiptActivity(configuration:any,notes:ReceivedCoupon[],orgId:number,now=Date.now()):any|null {
  const campaigns=Array.isArray(configuration)?configuration:[configuration]
  return campaigns.find(config=>Number(config?.orgId)===orgId && config?.mode==='coupon' && validWebActivity(config,now)
    && notes.some(note=>Number(note.id)===Number(config.couponId) && Number(note.orgId)===orgId)) || null
}
export function couponReceiptSafePath(path:string):boolean {
  return !/pay|orderconfirm|upgrade|deposite|login|request|upload|edit|makingboke|autoscale|[/]add/i.test(path)
}

export function couponReceiptSummaries(notes:ReceivedCoupon[]){
  const groups=new Map<string,{key:string;name:string;benefit:string;condition:string;scope:string;deadline:string;count:number}>(),ids=new Set<number>()
  for(const note of notes){
    const id=Number(note.customerNoteId);if(ids.has(id))continue;ids.add(id)
    const benefit=Number(note.noteType)===5?`${note.discountRate ?? note.amount}折`:`￥${note.amount}`
    const threshold=Number(note.threshold),condition=Number.isFinite(threshold) && threshold>=0?(threshold===0?'无门槛':`满${threshold}元可用`):'按券规则使用'
    const scope=couponTargets(note).map(target=>NoteTargeType[target]).filter(Boolean).join('、') || '以券包适用范围为准'
    const end=couponTimestamp(note.endTime),date=new Date(end),pad=(value:number)=>String(value).padStart(2,'0')
    const deadline=Number.isFinite(end)?`${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`:'以券包有效期为准'
    const name=note.noteName || '优惠券',key=JSON.stringify([note.orgId,note.id,name,benefit,condition,scope,end]),existing=groups.get(key)
    if(existing)existing.count++;else groups.set(key,{key,name,benefit,condition,scope,deadline,count:1})
  }
  return Array.from(groups.values())
}
